<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">			
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>				
			<template slot-scope="{ row, index }" slot="license">
				<a :href="row.license" target="_blank">点击查看</a>
			</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	
	</div>
</template>

<script>
	import api from '../../api'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			TableFuncs
		},
		data() {
			return {			
				queryParams: {
				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '公司名称',
						width: 200,
						key: 'companyName',
						align: 'center'
					},
					{
						title: '负责人姓名',
						key: 'userName',
						align: 'center',
						width: 200,
					},
					{
						title: '负责人手机',
						key: 'mobile',
						align: 'center',
						width: 150,
					},
					{
						title: '负责人微信号',
						key: 'wechart',
						align: 'center',
						width: 150,
					}, {
						title: '营业执照',
						slot: 'license',
						width: 200,
						align: 'center'
					}, {
						title: '日期',
						key: 'createTime',
						align: 'center',
						width: 200,
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change(){
				
			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.pushMerchantPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},	
			//导出数据
			exportExcel(){
				const that = this
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.exportJoin(queryParams)
					.then(res => {
						that.util.excel(res, "报名数据")
					})
			}		
		}

	}
</script>